export function isInTable(state) {
  var $head = state.selection.$head;
  for (var d = $head.depth; d > 0; d--) {
    if ($head.node(d).type.spec.tableRole === 'row') {
      return true;
    }
  }
  return false;
}
export function inSameTable($a, $b) {
  return $a.depth === $b.depth && $a.pos >= $b.start(-1) && $a.pos <= $b.end(-1);
}